<template>
  <div class="tw-pb-4 lg:tw-pb-0">
    <!-- Header -->
    <div class="tw-mb-5 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4">
      <div class="tw-space-y-2">
        <Skeleton class="tw-h-3 tw-w-24" />
        <Skeleton class="tw-h-7 tw-w-56" />
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <Skeleton class="tw-h-9 tw-w-20 tw-rounded-md" />
        <Skeleton class="tw-h-9 tw-w-24 tw-rounded-md" />
      </div>
    </div>

    <!-- Desktop two-pane -->
    <div
      class="tw-hidden tw-h-[calc(100vh-12rem)] tw-min-h-[420px] tw-grid-cols-[1fr_minmax(0,33%)] tw-overflow-hidden tw-rounded-2xl tw-border tw-border-surface-200 lg:tw-grid dark:tw-border-neutral-800"
    >
      <!-- Documents pane -->
      <div
        class="tw-flex tw-flex-col tw-border-r tw-border-surface-200 tw-bg-surface-50/60 tw-p-5 dark:tw-border-neutral-800 dark:tw-bg-neutral-900/40"
      >
        <Skeleton class="tw-mb-4 tw-h-4 tw-w-32" />
        <Skeleton class="tw-mb-4 tw-h-9 tw-w-48 tw-rounded-md" />
        <Skeleton class="tw-min-h-0 tw-flex-1 tw-w-full tw-rounded-xl" />
      </div>

      <!-- Details pane -->
      <div class="tw-p-5">
        <div
          class="tw-mb-6 tw-flex tw-gap-5 tw-border-b tw-border-surface-200 tw-pb-2 dark:tw-border-neutral-800"
        >
          <Skeleton class="tw-h-4 tw-w-16" />
          <Skeleton class="tw-h-4 tw-w-20" />
          <Skeleton class="tw-h-4 tw-w-14" />
        </div>
        <div class="tw-space-y-4">
          <div v-for="i in 9" :key="i" class="tw-flex tw-items-center tw-justify-between tw-gap-6">
            <Skeleton class="tw-h-4 tw-w-28" />
            <Skeleton class="tw-h-4 tw-w-20" />
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile stacked -->
    <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-hidden">
      <Skeleton class="tw-h-64 tw-w-full tw-rounded-2xl" />
      <Skeleton class="tw-h-48 tw-w-full tw-rounded-2xl" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton';
</script>
